module.exports = __webpack_public_path__ + "img/2.5ef6b7c7.png";